import { gql, useQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import { ErrorComponent } from "@src/components";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";
import LoadingComponent from "@src/components/LoadingComponent";
import { type GQLPackageQuery, type GQLPackageQueryVariables } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";

import EditForm from "./Form";
// eslint-disable-next-line @comet/no-private-sibling-import
import { packageFragment } from "./fragments.gql";

const packageQuery = gql`
    query Package($id: ID!) {
        package(id: $id) {
            ...PackageFragment
        }
    }
    ${packageFragment}
`;

interface Props {
    id: string;
}

export const EditPackage: FC<PropsWithChildren<Props>> = ({ id }) => {
    const { data, error, loading } = useQuery<GQLPackageQuery, GQLPackageQueryVariables>(packageQuery, { variables: { id } });

    if (error) {
        return <ErrorComponent />;
    }

    if (loading || !data) {
        return <LoadingComponent />;
    }

    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <EditForm package={data.package} />
                </Grid>
            </Grid>
        </>
    );
};
